<template>
  <TableBranchLocation />
</template>
<script>
import TableBranchLocation from "./components/tableBranchLocation";
export default {
  components: {
    TableBranchLocation,
  },
};
</script>
